(function () {
  if (window.strikemanProductShippingPolicyInitialized) return;
  window.strikemanProductShippingPolicyInitialized = true;

  var activeTrigger = null;

  function getOpenModal() {
    return document.querySelector('[data-strikeman-shipping-modal]:not([hidden])');
  }

  function getFocusable(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function openModal(trigger) {
    var modalId = trigger.getAttribute('aria-controls');
    var modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    activeTrigger = trigger;
    modal.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('strikeman-shipping-modal-open');

    var closeButton = modal.querySelector('[data-strikeman-shipping-close]');
    var dialog = modal.querySelector('[role="dialog"]');
    window.setTimeout(function () {
      (closeButton || dialog || modal).focus();
    }, 0);
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
    if (!getOpenModal()) document.documentElement.classList.remove('strikeman-shipping-modal-open');
    if (activeTrigger && typeof activeTrigger.focus === 'function') activeTrigger.focus();
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-strikeman-shipping-open]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    var closeControl = event.target.closest('[data-strikeman-shipping-close]');
    if (closeControl) {
      closeModal(closeControl.closest('[data-strikeman-shipping-modal]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var modal = getOpenModal();
    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(modal);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = getFocusable(modal);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
